// ─────────────────────────────────────────────────────────────────────────────
// payloads.js — Edit this file to change auction request payloads in the demo
//
// HOW TO EDIT:
//   • Change bidder IDs, publisher_score, bid_modifier values freely
//   • Update targeting, user, or any other fields to match your test scenarios
//   • The // comments next to bidder IDs are just for display — they won't be
//     sent to the API
//   • For side-by-side steps, edit textA and textB independently
//   • After saving, refresh the browser to see changes
// ─────────────────────────────────────────────────────────────────────────────

// Shared user block used across all payloads — edit once here to update everywhere
const USER = {
  guid: "demo-user-001",
  id: "demo",
  ip_address: "127.0.0.1",
  is_authenticated: false,
  culture: "en-US",
  currency: "USD",
  user_agent: "Mozilla/5.0",
};

// Helper to build the JSON object sent to the API (no comments)
// Helper to build display text with // comments shown in the UI
// For side-by-side steps, export { textA, textB, requestA, requestB }

// ─── STEP 1: Simple Sponsored Search ─────────────────────────────────────────
export const step1 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 4, slots_available: 4,
    bidders: [
      { id: "4694089", publisher_score: 1 },
      { id: "7196744", publisher_score: 1 },
      { id: "4314431", publisher_score: 1 },
      { id: "7369184", publisher_score: 1 },
      { id: "9414897", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 4,
  "slots_available": 4,
  "bidders": [
    { "id": "4694089", "publisher_score": 1 }, // HERSHEYS - CANDY, BAR CHOCOLATE ASSORTED IW
    { "id": "7196744", "publisher_score": 1 }, // HORMEL - BEEF, CRUMBLE COOKED IQF FROZEN TOPPING
    { "id": "4314431", "publisher_score": 1 }, // KELLOGG - PASTRY, POP TART CINNAMON BROWN SUGAR FROSTED IW SS
    { "id": "7369184", "publisher_score": 1 }, // KRAFT HEINZ - VINEGAR, CIDER APPLE DOMESTIC GLASS BOTTLE
    { "id": "9414897", "publisher_score": 1 }  // SARA LEE - PIE, SWEET POTATO PASTRY CRUST SLICE BAKED FROZEN SS IW
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 2: Single Winner ────────────────────────────────────────────────────
export const step2 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 1, slots_available: 4,
    bidders: [
      { id: "8491128", publisher_score: 1 },
      { id: "4886412", publisher_score: 1 },
      { id: "3259066", publisher_score: 1 },
      { id: "9263021", publisher_score: 1 },
      { id: "3014560", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 1,
  "slots_available": 4,
  "bidders": [
    { "id": "8491128", "publisher_score": 1 }, // HERSHEYS - CHOCOLATE, CHIP WHITE VANILLA PREMIER
    { "id": "4886412", "publisher_score": 1 }, // HORMEL - BEEF, TIP COOKED TRAY SHELF STABLE
    { "id": "3259066", "publisher_score": 1 }, // KELLOGG - CRACKER, CHEESE SQUARE SS BAG DISPLAY BOX
    { "id": "9263021", "publisher_score": 1 }, // KRAFT HEINZ - MAYONNAISE, DISPENSER POUCH SHELF STABLE
    { "id": "3014560", "publisher_score": 1 }  // SARA LEE - CAKE, SHEET 1/2 GERMAN CHOCOLATE ICED UNSLICED TRAY FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 3: Equal Relevance ──────────────────────────────────────────────────
export const step3 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1 },
      { id: "5624598", publisher_score: 1 },
      { id: "6872758", publisher_score: 1 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1 }, // HORMEL - CORNED BEEF, FLAT DELI-FACED SOLUTION ADDED 20% COOKED FRESH-TO-FROZEN CVP
    { "id": "5624598", "publisher_score": 1 }, // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K
    { "id": "6872758", "publisher_score": 1 }, // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE
    { "id": "2378339", "publisher_score": 1 }  // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 4: Relevance Boost ──────────────────────────────────────────────────
export const step4 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1 },
      { id: "5624598", publisher_score: 2 },
      { id: "6872758", publisher_score: 2 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1 }, // HORMEL - CORNED BEEF, FLAT DELI-FACED SOLUTION ADDED 20% COOKED FRESH-TO-FROZEN CVP
    { "id": "5624598", "publisher_score": 2 }, // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K (boosted)
    { "id": "6872758", "publisher_score": 2 }, // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE (boosted)
    { "id": "2378339", "publisher_score": 1 }  // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 5: Device Type Targeting ───────────────────────────────────────────
export const step5 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4694089", publisher_score: 1 },
      { id: "7196744", publisher_score: 1 },
      { id: "3259066", publisher_score: 1 },
      { id: "9263021", publisher_score: 1 },
      { id: "9414897", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: { device_type: "desktop" }, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4694089", "publisher_score": 1 }, // HERSHEYS - CANDY, BAR CHOCOLATE ASSORTED IW
    { "id": "7196744", "publisher_score": 1 }, // HORMEL - BEEF, CRUMBLE COOKED IQF FROZEN TOPPING
    { "id": "3259066", "publisher_score": 1 }, // KELLOGG - CRACKER, CHEESE SQUARE SS BAG DISPLAY BOX
    { "id": "9263021", "publisher_score": 1 }, // KRAFT HEINZ - MAYONNAISE, DISPENSER POUCH SHELF STABLE
    { "id": "9414897", "publisher_score": 1 }  // SARA LEE - PIE, SWEET POTATO PASTRY CRUST SLICE BAKED FROZEN SS IW
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {
    "device_type": "desktop"
  },
  "yield_management": {}
}`,
};

// ─── STEP 6: Division Targeting ───────────────────────────────────────────────
export const step6 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4694089", publisher_score: 1 },
      { id: "7196744", publisher_score: 1 },
      { id: "3259066", publisher_score: 1 },
      { id: "9263021", publisher_score: 1 },
      { id: "9414897", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: { division: "2140" }, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4694089", "publisher_score": 1 }, // HERSHEYS - CANDY, BAR CHOCOLATE ASSORTED IW
    { "id": "7196744", "publisher_score": 1 }, // HORMEL - BEEF, CRUMBLE COOKED IQF FROZEN TOPPING
    { "id": "3259066", "publisher_score": 1 }, // KELLOGG - CRACKER, CHEESE SQUARE SS BAG DISPLAY BOX
    { "id": "9263021", "publisher_score": 1 }, // KRAFT HEINZ - MAYONNAISE, DISPENSER POUCH SHELF STABLE
    { "id": "9414897", "publisher_score": 1 }  // SARA LEE - PIE, SWEET POTATO PASTRY CRUST SLICE BAKED FROZEN SS IW
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {
    "division": "2140"
  },
  "yield_management": {}
}`,
};

// ─── STEP 7: Keyword Targeting (Side-by-Side) ─────────────────────────────────
export const step7 = {
  requestA: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "5614623", publisher_score: 1 },
      { id: "4543740", publisher_score: 1 },
      { id: "8491128", publisher_score: 1 },
      { id: "7369184", publisher_score: 1 },
      { id: "9414897", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  textA: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "5614623", "publisher_score": 1 }, // HERSHEYS - CANDY, BAR MILK CHOCOLATE IW
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "8491128", "publisher_score": 1 }, // HERSHEYS - CHOCOLATE, CHIP WHITE VANILLA PREMIER
    { "id": "7369184", "publisher_score": 1 }, // KRAFT HEINZ - VINEGAR, CIDER APPLE DOMESTIC GLASS BOTTLE
    { "id": "9414897", "publisher_score": 1 }  // SARA LEE - PIE, SWEET POTATO PASTRY CRUST SLICE BAKED FROZEN SS IW
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
  requestB: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "5614623", publisher_score: 1 },
      { id: "4543740", publisher_score: 1 },
      { id: "8491128", publisher_score: 1 },
      { id: "7369184", publisher_score: 1 },
      { id: "9414897", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: { keyword: "chocolate" }, yield_management: {},
  },
  textB: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "5614623", "publisher_score": 1 }, // HERSHEYS - CANDY, BAR MILK CHOCOLATE IW
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "8491128", "publisher_score": 1 }, // HERSHEYS - CHOCOLATE, CHIP WHITE VANILLA PREMIER
    { "id": "7369184", "publisher_score": 1 }, // KRAFT HEINZ - VINEGAR, CIDER APPLE DOMESTIC GLASS BOTTLE
    { "id": "9414897", "publisher_score": 1 }  // SARA LEE - PIE, SWEET POTATO PASTRY CRUST SLICE BAKED FROZEN SS IW
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {
    "keyword": "chocolate"
  },
  "yield_management": {}
}`,
};

// ─── STEP 8: Price Floor (Side-by-Side) ──────────────────────────────────────
export const step8 = {
  requestA: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "8491128", publisher_score: 1 },
      { id: "4886412", publisher_score: 1 },
      { id: "4314431", publisher_score: 1 },
      { id: "7369184", publisher_score: 1 },
      { id: "3014560", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  textA: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "8491128", "publisher_score": 1 }, // HERSHEYS - CHOCOLATE, CHIP WHITE VANILLA PREMIER
    { "id": "4886412", "publisher_score": 1 }, // HORMEL - BEEF, TIP COOKED TRAY SHELF STABLE
    { "id": "4314431", "publisher_score": 1 }, // KELLOGG - PASTRY, POP TART CINNAMON BROWN SUGAR FROSTED IW SS
    { "id": "7369184", "publisher_score": 1 }, // KRAFT HEINZ - VINEGAR, CIDER APPLE DOMESTIC GLASS BOTTLE
    { "id": "3014560", "publisher_score": 1 }  // SARA LEE - CAKE, SHEET 1/2 GERMAN CHOCOLATE ICED UNSLICED TRAY FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
  requestB: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    minimum_bid_micros: 500000,
    bidders: [
      { id: "8491128", publisher_score: 1 },
      { id: "4886412", publisher_score: 1 },
      { id: "4314431", publisher_score: 1 },
      { id: "7369184", publisher_score: 1 },
      { id: "3014560", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  textB: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "8491128", "publisher_score": 1 }, // HERSHEYS - CHOCOLATE, CHIP WHITE VANILLA PREMIER
    { "id": "4886412", "publisher_score": 1 }, // HORMEL - BEEF, TIP COOKED TRAY SHELF STABLE
    { "id": "4314431", "publisher_score": 1 }, // KELLOGG - PASTRY, POP TART CINNAMON BROWN SUGAR FROSTED IW SS
    { "id": "7369184", "publisher_score": 1 }, // KRAFT HEINZ - VINEGAR, CIDER APPLE DOMESTIC GLASS BOTTLE
    { "id": "3014560", "publisher_score": 1 }  // SARA LEE - CAKE, SHEET 1/2 GERMAN CHOCOLATE ICED UNSLICED TRAY FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {
    "price_floor": 1.50
  }
}`,
};

// ─── STEP 9: Bid Modifier Baseline ───────────────────────────────────────────
export const step9 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1 },
      { id: "5624598", publisher_score: 1 },
      { id: "6872758", publisher_score: 1 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1 }, // HORMEL - CORNED BEEF, FLAT DELI-FACED SOLUTION ADDED 20% COOKED FRESH-TO-FROZEN CVP
    { "id": "5624598", "publisher_score": 1 }, // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K
    { "id": "6872758", "publisher_score": 1 }, // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE
    { "id": "2378339", "publisher_score": 1 }  // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 10: Bid Modifier in Action ─────────────────────────────────────────
export const step10 = {
  request: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1, bid_modifier: 1.5 },
      { id: "5624598", publisher_score: 1 },
      { id: "6872758", publisher_score: 1 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  text: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 },                    // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1, "bid_modifier": 1.5 }, // HORMEL - CORNED BEEF, FLAT DELI-FACED (boosted)
    { "id": "5624598", "publisher_score": 1 },                    // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K
    { "id": "6872758", "publisher_score": 1 },                    // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE
    { "id": "2378339", "publisher_score": 1 }                     // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};

// ─── STEP 11: Bid Modifier Side-by-Side ──────────────────────────────────────
export const step11 = {
  requestA: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1 },
      { id: "5624598", publisher_score: 1 },
      { id: "6872758", publisher_score: 1 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  textA: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 }, // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1 }, // HORMEL - CORNED BEEF, FLAT DELI-FACED SOLUTION ADDED 20% COOKED FRESH-TO-FROZEN CVP
    { "id": "5624598", "publisher_score": 1 }, // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K
    { "id": "6872758", "publisher_score": 1 }, // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE
    { "id": "2378339", "publisher_score": 1 }  // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
  requestB: {
    client_name: "US Foods", domain: "usfoods", site_id: "usfoods",
    page_name: "Search", experience_name: "Sponsored Search",
    max_requested: 3, slots_available: 4,
    bidders: [
      { id: "4543740", publisher_score: 1 },
      { id: "7089097", publisher_score: 1, bid_modifier: 1.5 },
      { id: "5624598", publisher_score: 1 },
      { id: "6872758", publisher_score: 1 },
      { id: "2378339", publisher_score: 1 },
    ],
    user: USER, model: {}, categories: {}, targeting: {}, yield_management: {},
  },
  textB: `{
  "client_name": "US Foods",
  "domain": "usfoods",
  "site_id": "usfoods",
  "page_name": "Search",
  "experience_name": "Sponsored Search",
  "max_requested": 3,
  "slots_available": 4,
  "bidders": [
    { "id": "4543740", "publisher_score": 1 },                    // HERSHEYS - TOPPING, CHOCOLATE DARK SPECIAL LIQUID SHELF STABLE SYRUP
    { "id": "7089097", "publisher_score": 1, "bid_modifier": 1.5 }, // HORMEL - CORNED BEEF (boosted)
    { "id": "5624598", "publisher_score": 1 },                    // KELLOGG - CEREAL, ASSORTED IW BREAKFAST KIT SPECIAL K
    { "id": "6872758", "publisher_score": 1 },                    // KRAFT HEINZ - KETCHUP, TOMATO 33% PLASTIC JUG SHELF STABLE
    { "id": "2378339", "publisher_score": 1 }                     // SARA LEE - PIE, BLUEBERRY 8" UNSLICED RAW FROZEN
  ],
  "user": {
    "guid": "demo-user-001",
    "id": "demo",
    "ip_address": "127.0.0.1",
    "is_authenticated": false,
    "culture": "en-US",
    "currency": "USD",
    "user_agent": "Mozilla/5.0"
  },
  "model": {},
  "categories": {},
  "targeting": {},
  "yield_management": {}
}`,
};